import CopyButton from './CopyButton';

export default CopyButton;
